// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RocketOutlinedSvg from "@ant-design/icons-svg/es/asn/RocketOutlined";
import AntdIcon from '../components/AntdIcon';

var RocketOutlined = function RocketOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RocketOutlinedSvg
  }));
};

RocketOutlined.displayName = 'RocketOutlined';
export default React.forwardRef(RocketOutlined);